import script from "./TopScoringListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopScoringListView.vue?vue&type=script&lang=ts&setup=true"

import "./TopScoringListView.vue?vue&type=style&index=0&id=7814f271&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7814f271"]])

export default __exports__